import { ISelectOption } from 'shared';

export class SupplierRegion {
    public supplierRegionID: string;
    public regionName: string;
    public assignedZipCodes: ISelectOption[];
    public isChanged: boolean;
    public lat: number;
    public long: number;
    public sameDayUtilization: number;
    public nextDaysUtilization: number;
    public useDynamicRouting: boolean;
    public shiftPickingToDeliveryRatio: number;
    public travelTimeMultiplier: number;
    public deliveryServiceTimeSeconds: number;
    public deliveryWindowEndToleranceSeconds: number;
}
